import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Loadpage from '@/components/Loadpage'
import PageEdit from '@/components/Page-edit'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/site/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/home'},
    
    { path: '/home', name: 'home', meta: { nav: true }, components:{main: Loadpage  }, props: {main: true, page:'mirko' } }, 
    { path: '/loadpage/:area/:filename', name: 'inside',  meta: { inside:'inside', nav: true }, components:{main: Loadpage },props: {main: true} }, 
    { path: '/page-edit', name: 'pageEdit', meta: { requiresAuth: false }, components: { main: PageEdit } },

    { path: '*', redirect: '/home' } 
  ]


})



router.beforeEach((to, from, next) => {
  console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path
  
  if(!teras.app.ready){
     if(teras.ttl()){
        console.log("TTLCLEAR lancio appClear")
        teras.event.emit('appClear')
     }
     console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
     teras.event.emit('routerFirst', to)
     return true
  }

  if (to.matched.some(record => record.meta.requiresAuth)){
     console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
     if(teras.app.auth){
        console.log("....PERMESSI VERIFICATI, PROCEDO!")
        next()
     }else{
        console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
        teras.event.emit('routerNoauth',to)
        next(teras.app.routeNoauth)
     }
  }else{
     console.log("NON SONO RICHIESTI PERMESSI")
     next()
  }

  teras.event.emit('routerChange', to)
})

export default router
